// removed by extract-text-webpack-plugin
module.exports = {"root":"src-pages-Practice-writing-overflow-root-3ocDW","box":"src-pages-Practice-writing-overflow-box-1vOOf","text":"src-pages-Practice-writing-overflow-text-3NrUp","t1":"src-pages-Practice-writing-overflow-t1-2TANo","t2":"src-pages-Practice-writing-overflow-t2-2w757","t3":"src-pages-Practice-writing-overflow-t3-kuKDH"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/pages/Practice/writing-overflow.css
 ** module id = 284
 ** module chunks = 0
 **/